import { useState, useEffect } from 'react';
import './App.css';
import Reader from './components/Reader';
import Gallery from './components/Gallery';
import Login from './components/Login';
// import albumsData from './albums.json';


function App()
{
  //* Hooks
  //? UseState => Gestion dynamique des variables sans rechargement de la page
  const [vue, setVue] = useState('galerie'); // 'galerie' ou 'lecteur'
  const [currentAlbum, setCurrentAlbum] = useState(null); // Pour gérer plusieurs albums
  //? API
  const [albumsData, setAlbumsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  //? Login
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  // ? Check for saved token and user in localStorage on component mount
  useEffect(() =>
  {
    const savedToken = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    if (savedToken && savedUser)
    {
      setToken(savedToken);
      setUser(JSON.parse(savedUser));
      setIsAuthenticated(true);
    } else
    {
      setLoading(false);
    }
  }, []);
  //? get albums from API if authenticated 
  useEffect(() =>
  {
    if (!isAuthenticated || !token) return;

    // Appel API pour récupérer les albums
    fetch('/api/albums',
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then((response) =>
      {
        if (!response.ok)
        {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) =>
      {
        setAlbumsData(data);
        setLoading(false);
      })
      .catch((error) =>
      {
        setError(error);
        setLoading(false);
      });
  }, [isAuthenticated, token]);

  //? Handlers
  const onSelectAlbum = (album) =>
  {
    setCurrentAlbum(album);
    setVue('lecteur');
  };
  const returnToTheGallery = () =>
  {
    setVue('galerie');
    setCurrentAlbum(null);
  };
  const handleLoginSuccess = (token, user) =>
  {
    setToken(token);
    setUser(user);
    setIsAuthenticated(true);
  };
  const handleLogout = () =>
  {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
    setIsAuthenticated(false);
    returnToTheGallery();
  };


  // rendu => JSX => HTML + injections dynamiques
  //? Si pas authentifié, afficher le composant Login
  if (!isAuthenticated)
  {
    return <Login onLoginSuccess={ handleLoginSuccess } />
  }

  return (
    <div className="App">
      <header>
        <h1>Ma galerie BD</h1>
        <div>
          <span>👤 { user?.username }</span>
          <button onClick={ handleLogout } className="logout-button">
            Logout
          </button>
        </div>
      </header>

      { loading && <p>Loading albums...</p> }

      { error && (
        <div className='errorDisplay'>
          <h3>⚠️ Error loading albums</h3>
          <p>{ error.message }</p>
          <button onClick={ () => window.location.reload() }>
            Retry
          </button>
        </div>
      ) }
      { !loading && !error && (
        vue === 'galerie' ?
          (<Gallery
            albums={ albumsData }
            onSelectAlbum={ onSelectAlbum }
          />) :
          (<Reader
            album={ currentAlbum }
            returnGallery={ returnToTheGallery }
          />)
      ) }

    </div>
  );
}

export default App;
